"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../schema");
const drugTypeName = schema_1.Schema.string().maxLength(1000);
const drugTypeDose = schema_1.Schema.string().optional().maxLength(100);
const drugType = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ drugTypeName, drugTypeDose }))
    .interpretation({ vocab: "ltx", code: "drug_type" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ drugType })
    .interpretation({ vocab: "ltx", code: "medical_treatment" });
